<template>
  <nav>
    <ul class="nav nav-tabs">
      <li v-for="tab in tabs" :key="tab" class="nav-item custom-tab">
        <button class="nav-link btn border" :class="[isActive(tab) ? 'btn-success' : 'btn-link']"
          :disabled="isActive(tab)" @click="setTab(tab)">
          {{ tab }}
        </button>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: 'dt-tabs',
  props: {
    value: String,
    tabs: Array
  },
  computed: {
    status: {
      get() {
        return this.value
      }
    }
  },
  methods: {
    isActive(tab) {
      let status = this.status || ''
      return status.toUpperCase() === tab.toUpperCase()
    },
    setTab(tab) {
      console.log('Setting Tab:', tab)
      this.$emit('change', tab)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-tab {
  position: relative;
}

button {
  padding: 13px 25px;
}

button:disabled {
  opacity: 1;
}

.message-badge {
  position: absolute;
  right: 4px;
  top: 4px;
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 15px;
  text-align: center;
  font-size: 0.6em;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-tabs.vue